export default "__VITE_ASSET__de35vWz___"